import EmployeeStep from "./employee/EmployeeStep";
import FieldsStep from "./fields/FieldsStep";
import HouserulesStep from "./houserules/HouseruleStep";
import MessagesStep from "./messages/MessagesStep";
import ParkingLocationStep from "./parking_location/ParkingLocationStep";
import PrintStep from "./print/PrintStep";
import QuestionnaireStep from "./questionnaire/QuestionnaireStep";
import ReferenceCheckStep from "./reference_check/ReferenceCheckStep";

export const steps = {
  fields: FieldsStep,
  houserules: HouserulesStep,
  employee: EmployeeStep,
  messages: MessagesStep,
  print: PrintStep,
  questionnaire: QuestionnaireStep,
  parking_location: ParkingLocationStep,
  reference_check: ReferenceCheckStep,
};

export function getStep(type) {
  return steps[type];
}
